export default __webpack_public_path__ + "static/media/entenda_4_revirado.7e1e3fb8.jpg";